import React from 'react';

interface Fact {
  label: string;
  value: string;
}

interface Props {
  title: string;
  subtitle: string;
  projectTitle: string;
  description: string;
  programme: string;
  facts: Fact[];
  subtitleGr: string;
  projectTitleGr: string;
  descriptionGr: string;
  programmeGr: string;
  factsGr: Fact[];
  imageEN: string;
  imageGR: string;
  identityLink: string;
  portalText: string;
  portalLink: string;
}

// Project block mirrors the ESPA A3 poster (Upiria_Αφίσα_Α3.pdf) field by field,
// so the auditor can cross-check page and poster directly.
const ProjectBlock = ({ projectTitle, description, programme, facts }: {
  projectTitle: string;
  description: string;
  programme: string;
  facts: Fact[];
}) => (
  <div className="greece20Project">
    <p className="greece20ProjectTitle">{projectTitle}</p>
    <p className="greece20ProjectDescription">{description}</p>
    <p className="articleDescription">{programme}</p>
    <dl className="greece20Facts">
      {facts.map((fact) => (
        <div key={fact.label}>
          <dt>{fact.label}</dt>
          <dd>{fact.value}</dd>
        </div>
      ))}
    </dl>
  </div>
);

const Greece20 = (props: Props) => {
  const {
    title,
    subtitle,
    projectTitle,
    description,
    programme,
    facts,
    subtitleGr,
    projectTitleGr,
    descriptionGr,
    programmeGr,
    factsGr,
    imageEN,
    imageGR,
    identityLink,
    portalText,
    portalLink,
  } = props;

  return (
    <>
      <div className="articleWrapper">
        <h1>{title}</h1>
        <h5>{subtitle}</h5>
        <ProjectBlock projectTitle={projectTitle} description={description} programme={programme} facts={facts} />
      </div>
      <div>
        <a href={identityLink} target="_blank" rel="noopener noreferrer">
          <img className="imgElavateWebEN" src={imageEN} alt="Greece 2.0 – Funded by the European Union NextGenerationEU" />
        </a>
      </div>
      <div className="articleWrapper">
        <h5>{subtitleGr}</h5>
        <ProjectBlock projectTitle={projectTitleGr} description={descriptionGr} programme={programmeGr} facts={factsGr} />
      </div>
      <div>
        <a href={identityLink} target="_blank" rel="noopener noreferrer">
          <img className="imgElavateWebEN" src={imageGR} alt="Ελλάδα 2.0 – Με τη χρηματοδότηση της Ευρωπαϊκής Ένωσης NextGenerationEU" />
        </a>
      </div>
      <div className="articleWrapper">
        <p className="articleDescription">
          <a href={portalLink} target="_blank" rel="noopener noreferrer">{portalText}</a>
        </p>
      </div>
    </>
  );
};

export default Greece20;
